




















import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters } from 'vuex';

interface Data {}

interface Methods {
  outsideClick: (e: Event) => void;
  downloadObjectDocs: (uuid: string) => void;
}

interface Computed {
  currentObjectDocs: { uuid: string; name: string; date: string }[];
}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'FlatDocumentsModal',
  props: {
    close: null,
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
    },
    ...mapActions(['downloadObjectDocs']),
  },
  computed: {
    ...mapGetters(['currentObjectDocs']),
  },
  mounted() {
    document.addEventListener('mousedown', this.outsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.outsideClick);
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
